import { City, CityId } from '../types/metro.types';

export const CITIES: City[] = [
  {
    id: 'delhi',
    name: 'Delhi',
    metroName: 'Delhi Metro',
    authorityName: 'Delhi Metro Rail Corporation',
    authorityAbbr: 'DMRC',
    officialWebsite: 'https://www.delhimetrorail.com',
    isOperational: true,
    lineCount: 10,
    stationCount: 265,
  },
  {
    id: 'mumbai',
    name: 'Mumbai',
    metroName: 'Mumbai Metro',
    authorityName: 'Mumbai Metropolitan Region Development Authority',
    authorityAbbr: 'MMRDA',
    officialWebsite: 'https://www.mumbaimetro.com',
    isOperational: true,
    lineCount: 4,
    stationCount: 63,
  },
  {
    id: 'bangalore',
    name: 'Bangalore',
    metroName: 'Namma Metro',
    authorityName: 'Bangalore Metro Rail Corporation Limited',
    authorityAbbr: 'BMRCL',
    officialWebsite: 'https://english.bmrc.co.in',
    isOperational: true,
    lineCount: 3,
    stationCount: 83,
  },
  {
    id: 'chennai',
    name: 'Chennai',
    metroName: 'Chennai Metro',
    authorityName: 'Chennai Metro Rail Limited',
    authorityAbbr: 'CMRL',
    officialWebsite: 'https://chennaimetrorail.org',
    isOperational: true,
    lineCount: 2,
    stationCount: 41,
  },
  {
    id: 'kolkata',
    name: 'Kolkata',
    metroName: 'Kolkata Metro',
    authorityName: 'Metro Railway Kolkata',
    authorityAbbr: 'MR',
    officialWebsite: 'https://mtp.indianrailways.gov.in',
    isOperational: true,
    lineCount: 5,
    stationCount: 51,
  },
  {
    id: 'hyderabad',
    name: 'Hyderabad',
    metroName: 'Hyderabad Metro',
    authorityName: 'Hyderabad Metro Rail Limited',
    authorityAbbr: 'HMRL',
    officialWebsite: 'https://hmrl.co.in',
    isOperational: true,
    lineCount: 3,
    stationCount: 56,
  },
  {
    id: 'jaipur',
    name: 'Jaipur',
    metroName: 'Jaipur Metro',
    authorityName: 'Jaipur Metro Rail Corporation',
    authorityAbbr: 'JMRC',
    officialWebsite: 'https://transport.rajasthan.gov.in/metro',
    isOperational: true,
    lineCount: 1,
    stationCount: 11,
  },
  {
    id: 'kochi',
    name: 'Kochi',
    metroName: 'Kochi Metro',
    authorityName: 'Kochi Metro Rail Limited',
    authorityAbbr: 'KMRL',
    officialWebsite: 'https://kochimetro.org',
    isOperational: true,
    lineCount: 1,
    stationCount: 25,
  },
  {
    id: 'lucknow',
    name: 'Lucknow',
    metroName: 'Lucknow Metro',
    authorityName: 'Uttar Pradesh Metro Rail Corporation',
    authorityAbbr: 'UPMRC',
    officialWebsite: 'https://lucknow.upmetrorail.com',
    isOperational: true,
    lineCount: 1,
    stationCount: 22,
  },
  {
    id: 'nagpur',
    name: 'Nagpur',
    metroName: 'Nagpur Metro',
    authorityName: 'Maharashtra Metro Rail Corporation Limited',
    authorityAbbr: 'MahaMetro',
    officialWebsite: 'https://www.metrorailnagpur.com',
    isOperational: true,
    lineCount: 2,
    stationCount: 31,
  },
  {
    id: 'ahmedabad',
    name: 'Ahmedabad',
    metroName: 'Ahmedabad Metro',
    authorityName: 'Gujarat Metro Rail Corporation',
    authorityAbbr: 'GMRC',
    officialWebsite: 'https://www.gujaratmetrorail.com',
    isOperational: true,
    lineCount: 4,
    stationCount: 54,
  },
  {
    id: 'noida',
    name: 'Noida',
    metroName: 'Noida Metro',
    authorityName: 'Noida Metro Rail Corporation',
    authorityAbbr: 'NMRC',
    officialWebsite: 'https://www.nmrcnoida.com',
    isOperational: true,
    lineCount: 1,
    stationCount: 21,
  },
  {
    id: 'kanpur',
    name: 'Kanpur',
    metroName: 'Kanpur Metro',
    authorityName: 'Uttar Pradesh Metro Rail Corporation',
    authorityAbbr: 'UPMRC',
    officialWebsite: 'https://kanpur.upmetrorail.com',
    isOperational: true,
    lineCount: 1,
    stationCount: 9,
  },
  {
    id: 'pune',
    name: 'Pune',
    metroName: 'Pune Metro',
    authorityName: 'Maharashtra Metro Rail Corporation Limited',
    authorityAbbr: 'MahaMetro',
    officialWebsite: 'https://www.punemetrorail.org',
    isOperational: true,
    lineCount: 2,
    stationCount: 30,
  },
  {
    id: 'navimumbai',
    name: 'Navi Mumbai',
    metroName: 'Navi Mumbai Metro',
    authorityName: 'City and Industrial Development Corporation',
    authorityAbbr: 'CIDCO',
    officialWebsite: 'https://cidco.maharashtra.gov.in',
    isOperational: true,
    lineCount: 1,
    stationCount: 11,
  },
  {
    id: 'agra',
    name: 'Agra',
    metroName: 'Agra Metro',
    authorityName: 'Uttar Pradesh Metro Rail Corporation',
    authorityAbbr: 'UPMRC',
    officialWebsite: 'https://agra.upmetrorail.com',
    isOperational: true,
    lineCount: 1,
    stationCount: 6,
  },
  {
    id: 'indore',
    name: 'Indore',
    metroName: 'Indore Metro',
    authorityName: 'Madhya Pradesh Metro Rail Corporation Limited',
    authorityAbbr: 'MPMRCL',
    officialWebsite: 'https://www.mpmetrorail.com',
    isOperational: true,
    lineCount: 1,
    stationCount: 5,
  },
  {
    id: 'patna',
    name: 'Patna',
    metroName: 'Patna Metro',
    authorityName: 'Patna Metro Rail Corporation Limited',
    authorityAbbr: 'PMRCL',
    officialWebsite: 'https://www.mypatnametro.com',
    isOperational: true,
    lineCount: 1,
    stationCount: 3,
  },
  {
    id: 'bhopal',
    name: 'Bhopal',
    metroName: 'Bhopal Metro',
    authorityName: 'Madhya Pradesh Metro Rail Corporation Limited',
    authorityAbbr: 'MPMRCL',
    officialWebsite: 'https://www.mpmetrorail.com',
    isOperational: true,
    lineCount: 1,
    stationCount: 8,
  },
  {
    id: 'meerut',
    name: 'Meerut',
    metroName: 'Namo Bharat RRTS',
    authorityName: 'National Capital Region Transport Corporation',
    authorityAbbr: 'NCRTC',
    officialWebsite: 'https://ncrtc.in',
    isOperational: true,
    lineCount: 1,
    stationCount: 13,
  },
  {
    id: 'varanasi',
    name: 'Varanasi',
    metroName: 'Varanasi Metrolite',
    authorityName: 'Uttar Pradesh Metro Rail Corporation',
    authorityAbbr: 'UPMRC',
    officialWebsite: 'https://upmetrorail.com',
    isOperational: false,
    lineCount: 0,
    stationCount: 0,
  },
  {
    id: 'surat',
    name: 'Surat',
    metroName: 'Surat Metro',
    authorityName: 'Gujarat Metro Rail Corporation',
    authorityAbbr: 'GMRC',
    officialWebsite: 'https://www.gujaratmetrorail.com',
    isOperational: false,
    lineCount: 0,
    stationCount: 0,
  },
  {
    id: 'vizag',
    name: 'Visakhapatnam',
    metroName: 'Vizag Metro',
    authorityName: 'Andhra Pradesh Metro Rail Corporation',
    authorityAbbr: 'APMRC',
    officialWebsite: 'https://vizagmetro.com.in',
    isOperational: false,
    lineCount: 0,
    stationCount: 0,
  },
  {
    id: 'guwahati',
    name: 'Guwahati',
    metroName: 'Guwahati Metro',
    authorityName: 'Guwahati Metro Rail Corporation Limited',
    authorityAbbr: 'GMRCL',
    officialWebsite: 'https://gmda.assam.gov.in',
    isOperational: false,
    lineCount: 0,
    stationCount: 0,
  },
];

export const getCityById = (id: CityId): City | undefined => {
  return CITIES.find(city => city.id === id);
};

export const getOperationalCities = (): City[] => {
  return CITIES.filter(city => city.isOperational);
};

export const getNonOperationalCities = (): City[] => {
  return CITIES.filter(city => !city.isOperational);
};
